import app from './app/messages_ja.json';
import rooms from './dungeon/rooms_ja.json';
import names from './dungeon/names_ja.json';
import reasons from './dungeon/reasons_ja.json';
import status from './dungeon/status_ja.json';
import entrances from './dungeon/entrances_ja.json';
import guards from './dungeon/guards_ja.json';
import distinctiveFeatures from './dungeon/distinctiveFeatures_ja.json';
import inhabitants from './dungeon/inhabitants_ja.json';
import dangers from './dungeon/dangers_ja.json';

export default {
  ...app,
  ...rooms,
  ...names,
  ...reasons,
  ...status,
  ...entrances,
  ...guards,
  ...distinctiveFeatures,
  ...inhabitants,
  ...dangers,
};
